import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class Response {
  constructor() {
    _defineProperty(this, "ResponseCode", {
      fieldName: 'code',
      content: null
    });
    _defineProperty(this, "ResponseData", {
      fieldName: 'data',
      content: null
    });
    _defineProperty(this, "ResponseMessages", {
      fieldName: 'messages',
      content: null
    });
  }
  getData() {
    return this.ResponseData.content;
  }
}
export default Response;